import React from 'react';
import think from '../../imgs/think.png';
export default class Plane1 extends React.Component {
  render() {
    return (
      <div className='typography-container'>

    <h1>Звуковой барьер</h1>
<p>
    Сверхзвуковая скорость — это движение быстрее звука. Скорость звука
    различается в зависимости от среды распространения и ее температуры. Для
    простоты принято считать, что в нормальных условиях в воздухе она
    составляет 331 метр в секунду, или 1191 километр в час. В авиации для
    измерения скорости введено понятие числа Маха. Оно представляет собой
    отношение скорости течения газового потока к скорости звука в движущейся
    среде. Опять же для простоты одно число Маха принято считать равным 1,2
    тысячи километров в час.
</p>
<p>
    Впервые звуковой барьер был преодолен в 1947 году американским летчиком
    Чаком Йегером. После его полета конструкторам пришлось решать массу новых
    задач, о которых они и не подозревали раньше — например, волнового кризиса
    и флаттера (эти явления проявляются сильными вибрациями и потерей
    управления на разных скоростях полета).
</p>
<p>
    Другая проблема — шум. В 2006-м и 2008 годах Международная организация
    гражданской авиации приняла новые стандарты авиационного шума, помимо
    прочего запретившие сверхзвуковые полеты над населенной сушей.
</p>
<p>
    Когда какой-либо объект движется в воздухе на скорости, превосходящей
    скорость звука, на перепадах его поверхности образуются ударные волны. В
    случае с самолетом ударные волны появляются на передних кромках его
    аэродинамических поверхностей. Ударная волна представляет собой небольшую
    область, в которой давление, плотность и температура среды испытывают
    резкий и сильный скачок. Когда над человеком на высоте на сверхзвуковой
    скорости пролетает самолет, через некоторое время слышится очень громкий
    хлопок, звуковой удар: это ударные волны долетели от самолета до
    наблюдателя.
</p>
<h1>Подумай:</h1>
<p align='center'>
<img alt='' src={think} />
</p>
<p>
  1. Почему сверхзвуковой самолет летит на высоте в два раза большей, чем обычный самолет ( 18 км против 9-10 км )
</p>
<p>
  2. Какое физическое явление возникает и действует отрицательно на самолет при полете на большой высоте со сверхзвуковой скоростью?
</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Plane-1.js